(() => {
  const guardScript = document.currentScript;
  const cartUrl = guardScript?.dataset.cartUrl || '/cart';
  const guardedForms = new WeakSet();
  const resubmittingForms = new WeakSet();

  function hasDiscontinuedItems(cartHtml) {
    const cartDocument = new DOMParser().parseFromString(cartHtml, 'text/html');
    return [...cartDocument.querySelectorAll('.cart-item[data-product-discontinued]')].some(
      (item) => item.getAttribute('data-product-discontinued')?.trim().toLowerCase() === 'true',
    );
  }

  function getCartRedirectUrl() {
    const url = new URL(cartUrl, window.location.origin);
    url.searchParams.set('show_discontinued', 'true');
    return url.toString();
  }

  async function inspectCart() {
    const response = await fetch(cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`Cart check failed: ${response.status}`);
    return hasDiscontinuedItems(await response.text());
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('#CartDrawer-Form, #cart-notification-form')) return;

    if (resubmittingForms.has(form)) {
      resubmittingForms.delete(form);
      return;
    }

    event.preventDefault();
    if (guardedForms.has(form)) return;
    guardedForms.add(form);

    try {
      if (await inspectCart()) {
        window.location.assign(getCartRedirectUrl());
        return;
      }

      resubmittingForms.add(form);
      form.requestSubmit(event.submitter || undefined);
    } catch (error) {
      window.location.assign(getCartRedirectUrl());
    } finally {
      guardedForms.delete(form);
    }
  }, true);
})();